import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import { APP_URLS } from '../../helpers/url_helper';
import './StripePayment.css';

// Import assets (using existing SVG that looks like cancel/error)
import prohibitedIcon from '../../assets/Prohibited.svg';

function PaymentCancel() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sessionData, setSessionData] = useState(null);

  // Initialize theme on component mount
  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  // Get session details from URL params
  useEffect(() => {
    const planName = searchParams.get('plan');
    const billingCycle = searchParams.get('billing');
    
    setSessionData({
      planName: planName || 'Selected Plan',
      billingCycle: billingCycle || 'monthly'
    });
  }, [searchParams]);

  const handleTryAgain = () => {
    navigate(APP_URLS.SUBSCRIPTION);
  };

  const handleGoToDashboard = () => {
    navigate(APP_URLS.DASHBOARD);
  };

  return (
    <div className="payment-result-page">
      <div className="payment-cancel-centered-layout">
        {/* Centered Header */}
        <div className="cancel-header-centered">
          <h1 className="payment-title cancel-title">
            <img src={prohibitedIcon} alt="Payment Cancelled" className="cancel-main-icon" />
            Payment Cancelled
          </h1>
          <p className="payment-message">
            Your payment was cancelled and no charges were made to your account.
          </p>
        </div>

        {/* Two Boxes Side by Side */}
        <div className="cancel-boxes-container">
          {/* Help Information Box */}
          <div className="cancel-box help-info-box">
            <h5 className="help-title">Need Help?</h5>
            <ul className="help-list">
              <li>You can try the payment process again</li>
              <li>Contact our support team if you're experiencing issues</li>
              <li>Continue using your current plan features</li>
            </ul>
          </div>

          {/* Cancelled Plan Details Box */}
          <div className="cancel-box cancelled-plan-box">
            <h4 className="details-title">Cancelled Subscription</h4>
            
            {sessionData ? (
              <>
                <div className="detail-item">
                  <span className="detail-label">Plan:</span>
                  <span className="detail-value">{sessionData.planName}</span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">Billing:</span>
                  <span className="detail-value">
                    {sessionData.billingCycle === 'yearly' ? 'Yearly' : 'Monthly'}
                  </span>
                </div>
                
                <div className="detail-item">
                  <span className="detail-label">Status:</span>
                  <span className="detail-value cancelled-status">Cancelled</span>
                </div>
              </>
            ) : (
              <div className="detail-item">
                <span className="detail-label">Status:</span>
                <span className="detail-value cancelled-status">Payment Cancelled</span>
              </div>
            )}
          </div>
        </div>

        {/* Centered Action Buttons */}
        <div className="cancel-actions-centered">
          <Button 
            variant="primary" 
            className="action-btn primary-action"
            onClick={handleTryAgain}
          >
            Try Again
          </Button>
          <Button 
            variant="outline-secondary" 
            className="action-btn secondary-action"
            onClick={handleGoToDashboard}
          >
            Go to Dashboard
          </Button>
        </div>

        {/* Support Information */}
        <div className="support-info-centered">
          <p className="support-text">
            Having trouble? Contact our support team at{' '}
            <a href="mailto:support@complimate.com.au" className="support-link">
              support@complimate.com.au
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
